import { createFileRoute } from "@tanstack/react-router";
import { InterviewSettingsPage } from "~/pages/InterviewSettingsPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/interviews")({
  component: InterviewSettingsPage,
});
